'use strict';

namespace Core {

    /**
     * If we receive a route that does not match any of our static routes
     * we will end up here. We will then call an api to check whether this is
     * a dynamic route of some kind. If we still don't understand the route
     * just send the user to the home page.
     */

    interface IStatistics {
        numberOfAirlines : number;
        numberOfHotels : number;
        bookingsLastHour : number;
        customersCurrentlyOnHoliday : number;
        reviewCount : number;
        searchesInLastHour : number;
        villaCount : number;
    }

    class DynamicRouting {

        template : string;
        data : IStatistics;
        minimalRoutes: RegExp[] = [
            /^\/famous-film-locations$/,
            /^\/famous-film-locations\/.+/
        ];

        constructor(private $location : ng.ILocationService,
                    private publicityService:any,
                    private broker: Core.Broker) {

            if (TRPCONFIG.DeviceSettings.PublicityMessagingEnabled) {
                publicityService.getStats({
                    StatisticTypes: 'All'
                }).then((data:any) => {
                    this.data = {
                        numberOfAirlines : data.AirlineCount.Value,
                        numberOfHotels : data.EstabCount.Value,
                        bookingsLastHour : data.BookingsInLastHour.Value,
                        customersCurrentlyOnHoliday : data.CustomersCurrentlyOnHoliday.Value,
                        reviewCount : data.ReviewCount.Value,
                        searchesInLastHour : data.SearchesInLastHour.Value,
                        villaCount : data.VillaCount.Value
                    };
                });
            }
            this.template = `cms/page${$location.path()}`;
            const path = $location.path();
            const minimal = this.minimalRoutes.reduce((matched, re) => matched || re.test(path), false);
            this.template = `cms/page${path}`;
            if(minimal) {
                broker.publish('stripHeader');
                broker.publish('hideFooter');
            }
        }
    }

    angular
        .module('core')
        .controller('DynamicRouting', DynamicRouting);

}

